// @ts-expect-error - Automatic, Please fix when editing this file
const selectProductIdsFromParams = (state, props) => props?.match?.params?.productIds ?? null;

export default selectProductIdsFromParams;
